// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MEDIA_BREAKPOINTS, DWEB_MAX_WIDTH } from 'shared/styles/base';

export const WidgetHeaderwithoutBorder = styled.h2`
  padding: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing60}`};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleLarge};
  display: flex;
  justify-content: space-between;
  margin: 0;

  ${MEDIA_BREAKPOINTS.TILL_TABLET} {
    ${({ theme }) => theme.typography.titleSmall};
    padding: ${({ theme }) => `${theme.spacing.spacing80} 0 ${theme.spacing.spacing80}`};
  }
`;

export const WidgetWrapperSection = styled.section<{ hasPadding: boolean; showTopBorder: boolean }>`
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing120}`};
  scroll-behavior: smooth;
  ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing60}`};
  }

  ${MEDIA_BREAKPOINTS.TILL_TABLET} {
    ${({ hasPadding, theme }) =>
      hasPadding ? `padding: 0 ${theme.spacing.spacing60};` : `padding: 0px;`}

    ${({ theme, showTopBorder }) =>
      showTopBorder && `border-top: 1px solid ${theme.colors.textOutline}`};
  }

  ${MEDIA_BREAKPOINTS.MOBILE} {
    ${({ hasPadding, theme }) =>
      hasPadding ? `padding: 0 ${theme.spacing.spacing80};` : `padding: 0px;`}
  }
`;

export const WidgetContainer = styled.div`
  width: 100vw;
  max-width: ${DWEB_MAX_WIDTH}px;
  margin-left: -${({ theme }) => theme.spacing.spacing80};
`;
